import React from 'react';
import Icon from '../../../components/AppIcon';

const LicenseCredentials = () => {
  const credentials = [
    {
      title: 'California State Licensed',
      subtitle: 'Bail Agent License #BA-2024-001',
      icon: 'Award',
      verified: true
    },
    {
      title: 'Sacramento County Certified',
      subtitle: 'Facility Access Authorization',
      icon: 'MapPin',
      verified: true
    },
    {
      title: 'Professional Bonding',
      subtitle: 'Insured & Bonded Services',
      icon: 'Shield',
      verified: true
    }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6 shadow-soft">
      <div className="text-center mb-6">
        <h3 className="text-lg font-semibold text-foreground mb-2">
          Professional Credentials
        </h3>
        <p className="text-sm text-muted-foreground">
          Licensed & Certified Bail Bond Services
        </p>
      </div>
      <div className="space-y-4">
        {credentials?.map((credential, index) => (
          <div key={index} className="flex items-start space-x-3">
            <div className="flex-shrink-0 w-8 h-8 bg-accent/10 rounded-lg flex items-center justify-center">
              <Icon name={credential?.icon} size={16} color="var(--color-accent)" />
            </div>
            
            <div className="flex-1 min-w-0">
              <div className="flex items-center space-x-2">
                <h4 className="text-sm font-medium text-foreground">
                  {credential?.title}
                </h4>
                {credential?.verified && (
                  <Icon name="CheckCircle" size={14} color="var(--color-accent)" />
                )}
              </div>
              <p className="text-xs text-muted-foreground mt-1">
                {credential?.subtitle}
              </p>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-6 pt-4 border-t border-border text-center">
        <div className="flex items-center justify-center space-x-2">
          <Icon name="Clock" size={14} color="var(--color-accent)" />
          <span className="text-xs text-accent font-medium">24/7 Available</span>
        </div>
        <p className="text-xs text-muted-foreground mt-1">
          Emergency Bail Services
        </p>
      </div>
    </div>
  );
};

export default LicenseCredentials;